import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-i",
  "use": "icon-i-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-i\"><defs><style type=\"text/css\"></style></defs><path d=\"M682.666667 85.333333L512 938.666667h170.666667v85.333333H170.666667v-85.333333h170.666666L512 85.333333H341.333333V0h512v85.333333H682.666667z\" p-id=\"2758\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/i.svg
// module id = 7Sbe
// module chunks = 31